import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Home from './Home';
import Login from './Login';
import FileManagerPage from './FileManagerPage';
import HomeLogin from './HomeLogin';
import ToDo from './ToDo';
import Logout from './Logout';
import Inventory from './Inventory';
import "./css/index.css";

import { AuthContextProvider } from "./auth";
import ProtectedRoute from "./auth/ProtectedRoute";

function App() {
  return (
    <AuthContextProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route
            path="/homelogin"
            element={
              <ProtectedRoute>
                <HomeLogin />
              </ProtectedRoute>
            }
          />

          <Route
            path="/logout"
            element={
              <ProtectedRoute>
                <Logout />
              </ProtectedRoute>
            }
          />

          <Route
            path="/file"
            element={
              <ProtectedRoute>
                <FileManagerPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/todo"
            element={
              <ProtectedRoute>
                <ToDo />
              </ProtectedRoute>
            }
          />

          <Route
            path="/inventory"
            element={
              <ProtectedRoute>
                <Inventory />
              </ProtectedRoute>
            }
          />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </AuthContextProvider>
  );
}

export default App;